"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Regex = void 0;
exports.Regex = {
    PasswordRegex: /(?=^.{8,}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!@#$%^&*()_]*$/,
};
//# sourceMappingURL=Regex.js.map